'use client';

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// UI lib components
import { Checkbox as NativeCheckbox } from '@mantine/core';

// Style
import * as classes from './styles/index.css';
import * as checkboxStylesAPI from './styles/checkboxStylesAPI.css';

// Types
import { CheckboxProps } from './types';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

function Checkbox(props: CheckboxProps) {
  /* ********************************** HOOKS ********************************* */

  // Style

  /* ******************************** RENDERING ******************************* */
  return (
    <NativeCheckbox
      className={classes.checkbox}
      classNames={{ ...checkboxStylesAPI }}
      radius="xs"
      size="xs"
      {...props}
    />
  );
}

export default Checkbox;
